var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.02 20.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.15,
    y: 16.66,
    width: 22.5,
    height: 1.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.88,3.6A1.43,1.43,0,1,1,4.45,2.18,1.43,1.43,0,0,1,5.88,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.88,3.6A1.43,1.43,0,1,1,4.45,2.18,1.43,1.43,0,0,1,5.88,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.38,2.18a1.37,1.37,0,0,0-.61.14A2.05,2.05,0,0,1,7.22,3.6a2.08,2.08,0,0,1-.45,1.29A1.52,1.52,0,0,0,7.38,5a1.43,1.43,0,0,0,0-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.38,2.18a1.37,1.37,0,0,0-.61.14A2.05,2.05,0,0,1,7.22,3.6a2.08,2.08,0,0,1-.45,1.29A1.52,1.52,0,0,0,7.38,5a1.43,1.43,0,0,0,0-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.56,11.44H3a.36.36,0,0,1-.35-.36A.36.36,0,0,1,3,10.72H5.56a.36.36,0,0,1,.36.36.36.36,0,0,1-.36.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.56,11.44H3a.36.36,0,0,1-.35-.36A.36.36,0,0,1,3,10.72H5.56a.36.36,0,0,1,.36.36A.36.36,0,0,1,5.56,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.46,11.44H7.87a.36.36,0,0,1-.36-.36.36.36,0,0,1,.36-.36h2.59a.36.36,0,0,1,.35.36.36.36,0,0,1-.35.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.46,11.44H7.87a.36.36,0,0,1-.36-.36.36.36,0,0,1,.36-.36h2.59a.36.36,0,0,1,.35.36A.36.36,0,0,1,10.46,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.35,11.44H12.76a.36.36,0,0,1-.35-.36.36.36,0,0,1,.35-.36h2.59a.36.36,0,0,1,.36.36.36.36,0,0,1-.36.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.35,11.44H12.76a.36.36,0,0,1-.35-.36.36.36,0,0,1,.35-.36h2.59a.36.36,0,0,1,.36.36A.36.36,0,0,1,15.35,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.25,11.44H17.66a.36.36,0,0,1-.36-.36.36.36,0,0,1,.36-.36h2.59a.36.36,0,0,1,.35.36.36.36,0,0,1-.35.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.25,11.44H17.66a.36.36,0,0,1-.36-.36.36.36,0,0,1,.36-.36h2.59a.36.36,0,0,1,.35.36A.36.36,0,0,1,20.25,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.82.72a1.1,1.1,0,0,0-1.1,1.1V12.94A1.1,1.1,0,0,0,1.82,14H21.4a1.1,1.1,0,0,0,1.1-1.1V1.82A1.1,1.1,0,0,0,21.4.72Zm19.58,14H1.82A1.83,1.83,0,0,1,0,12.94V1.82A1.83,1.83,0,0,1,1.82,0H21.4a1.83,1.83,0,0,1,1.82,1.82V12.94a1.83,1.83,0,0,1-1.82,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.15,20.61H6.66a1.87,1.87,0,0,1-1.87-1.87V15.46a.36.36,0,1,1,.72,0v3.28A1.16,1.16,0,0,0,6.66,19.9H26.15a1.16,1.16,0,0,0,1.15-1.16v-11a1.16,1.16,0,0,0-1.15-1.15H22.86a.36.36,0,0,1,0-.72h3.29A1.87,1.87,0,0,1,28,7.72v11a1.87,1.87,0,0,1-1.87,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.7,5H17a.55.55,0,0,1-.55-.55V2.73A.55.55,0,0,1,17,2.18H19.7a.55.55,0,0,1,.55.55V4.48A.55.55,0,0,1,19.7,5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.41,
    y: 2.18,
    width: 3.83,
    height: 2.84,
    rx: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.c5b58602.svg";
export { ForwardRef as ReactComponent };